import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import Contato from "@/pages/Contato";

export const Route = createFileRoute("/contato")({
  head: () => seoHead({
    title: "Contato | Shopping do Bem",
    description: "Entre em contato com o Shopping do Bem.",
    path: "/contato",
  }),
  component: Contato,
});
